import React from 'react';
import { Box } from '@mui/material';

import { getAvailableCandidateVideoUrlAPI } from '@constants';
import { IAvailableCandidate } from '@types';
import { allocationNote } from '@utils';
import { AssessmentFacts } from 'components/candidate/CandidateDetailSections/components/AssessmentBlock';
import {
  Fact,
  Row,
} from 'components/candidate/CandidateDetailSections/components/DetailFacts';
import { OpenResumeButton } from 'components/candidate/CandidateDetailSections/components/OpenResumeButton';
import { PersonFacts } from 'components/candidate/CandidateDetailSections/components/ProfileFacts';
import { ICandidateSection } from 'components/candidate/CandidateDetailSections/CandidateDetailSections';
import { VideoIntro } from 'components/candidate/CandidateVideoIntro/CandidateVideoIntro';
import { AvailableFromCell } from './AvailableFromCell';

export const getAvailableCandidateSections = (
  candidate: IAvailableCandidate,
  onOpenResume: (candidateId: string) => void,
  { includeVideo = true } = {},
): ICandidateSection[] => [
  {
    title: 'Assessment',
    content: (
      <AssessmentFacts
        ranking={candidate.ranking}
        testTask={{
          score: candidate.testTask.score,
          status: null,
          isPending: false,
        }}
      >
        {candidate.hasResume && (
          <Fact label="Full resume">
            <OpenResumeButton onOpen={() => onOpenResume(candidate.id)} />
          </Fact>
        )}
      </AssessmentFacts>
    ),
  },
  ...(includeVideo && candidate.hasVideo
    ? [
        {
          title: 'Video intro',
          content: (
            <VideoIntro
              videoUrlAPI={getAvailableCandidateVideoUrlAPI(candidate.id)}
            />
          ),
        },
      ]
    : []),
  {
    title: 'Profile',
    content: (
      <Box>
        <PersonFacts profile={candidate} />
        {(candidate.availability.kind !== 'empty' ||
          Boolean(allocationNote(candidate))) && (
          <Row label="Available from">
            <AvailableFromCell candidate={candidate} />
          </Row>
        )}
      </Box>
    ),
  },
];
